import { AnalyzeError } from "#modules/quoteRequestLines/AnalyzeError";

type Props = {
  errorText: string;
  retryText: string;
  secondaryRetryText?: string;
  onRetryPrediction: () => void;
  openDetailsPanel?: () => void;
};

export const PredictionErrorState = ({
  errorText,
  retryText,
  secondaryRetryText,
  onRetryPrediction,
  openDetailsPanel,
}: Props) => {
  return (
    <AnalyzeError
      retryText={retryText}
      errorText={errorText}
      retryAction={onRetryPrediction}
      secondaryRetryText={secondaryRetryText}
      secondaryRetryAction={openDetailsPanel}
    />
  );
};
